<template>
  <v-layout class="mt-2" row>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-list>
          <v-list-tile
            v-for="person in people"
            :key="person.id"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ person.firstName }} {{ person.lastName }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    computed: {
      ...mapGetters(["people"])
    },
    data () {
      return {};
    },
    mounted () {
      this.$nextTick(() => {
        this.$store.dispatch("loadPeople");
      });
    }
  };
</script>
